(() => {
  "use strict";
  if (customElements.get("guru-image-viewer")) return;

  customElements.define("guru-image-viewer", class extends HTMLElement {
    #controller;
    #dialog;
    #trigger;
    #image;
    #overflow;
    #pointer;
    #outside = false;

    connectedCallback() {
      this.#controller?.abort();
      this.#controller = new AbortController();
      const { signal } = this.#controller;
      this.#dialog = this.querySelector("dialog");
      const owner = this.closest("guru-product-page");
      if (!owner || !this.#dialog?.showModal) return;

      owner.addEventListener("pointerdown", (event) => {
        this.#pointer = { x: event.clientX, y: event.clientY };
      }, { signal });
      owner.addEventListener("click", (event) => {
        const trigger = event.target.closest("[data-image-viewer-trigger]");
        if (!trigger || event.defaultPrevented || event.button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        if (event.detail && this.#pointer && Math.hypot(event.clientX - this.#pointer.x, event.clientY - this.#pointer.y) > 10) return;
        this.#open(trigger);
      }, { signal });
      this.#dialog.querySelector(".guru-image-viewer__close").addEventListener("click", () => this.#close(), { signal });
      this.#dialog.addEventListener("pointerdown", (event) => { this.#outside = event.target === this.#dialog; }, { signal });
      this.#dialog.addEventListener("click", (event) => {
        if (event.target === this.#dialog && this.#outside) this.#close();
      }, { signal });
      this.#dialog.addEventListener("cancel", (event) => { event.preventDefault(); this.#close(); }, { signal });
      // Native close events are queued; an earlier close must not unlock a new opening.
      this.#dialog.addEventListener("close", () => { if (!this.#dialog.open) this.#restore(); }, { signal });
    }

    disconnectedCallback() {
      this.#close();
      this.#controller?.abort();
    }

    #close() {
      this.#dialog?.close();
      this.#restore();
    }

    #open(trigger) {
      if (this.#dialog.open) return;
      this.#trigger = trigger;
      const status = this.#dialog.querySelector(".guru-image-viewer__status");
      const loading = this.#dialog.querySelector("[data-image-viewer-loading]");
      const error = this.#dialog.querySelector("[data-image-viewer-error]");
      status.hidden = false;
      loading.hidden = false;
      error.hidden = true;
      this.#dialog.querySelector(".guru-image-viewer__fallback").href = trigger.href;
      const image = new Image();
      image.className = "guru-image-viewer__image";
      image.alt = trigger.dataset.imageAlt || "";
      image.hidden = true;
      image.onload = () => {
        if (image !== this.#image) return;
        image.hidden = false;
        status.hidden = true;
      };
      image.onerror = () => {
        if (image !== this.#image) return;
        loading.hidden = true;
        error.hidden = false;
      };
      this.#image = image;
      this.#dialog.querySelector(".guru-image-viewer__panel").insertBefore(image, status);
      this.#overflow = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      this.#dialog.showModal();
      image.src = trigger.href;
    }

    #restore() {
      if (this.#overflow === undefined) return;
      document.body.style.overflow = this.#overflow;
      this.#overflow = undefined;
      if (this.#image) {
        this.#image.onload = null;
        this.#image.onerror = null;
        this.#image.remove();
        this.#image = null;
      }
      if (this.#trigger?.isConnected) this.#trigger.focus({ preventScroll: true });
      this.#trigger = null;
    }
  });
})();
